import script from "./navigator.vue?vue&type=script&setup=true&lang=js"
export * from "./navigator.vue?vue&type=script&setup=true&lang=js"

import "./navigator.vue?vue&type=style&index=0&id=9f511f88&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f511f88"]])

export default __exports__